export default __webpack_public_path__ + "static/media/googlePlay.b8ba0f9f.svg";